import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
};

const currentPageSlice = createSlice({
  name: "currentPageSlice",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});

export const { setCurrentPage } = currentPageSlice.actions;
export default currentPageSlice.reducer;
